import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryOpenJobServices from '../services/job/query.open.job.services';
import getJobService from '../services/job/get.job.service';
import getJobReports from '../services/job/get.job.reports';

// THUNKS
export const fetchOpenJobServices = createAsyncThunk('jobs/fetchOpenJobServices', queryOpenJobServices.handler);
export const fetchJobServiceDetails = createAsyncThunk('jobs/fetchJobServiceDetails', getJobService.handler);
export const fetchJobServiceReports = createAsyncThunk('jobs/fetchJobServiceReports', getJobReports.handler);

const initial_state = {
  loading: false,
  is_first_loading: true,
  items: [],
  next_token: null,
  details: null,
  reports: [],
};

// slice definition
const slice = createSlice({
  name: 'jobs',
  initialState: initial_state,
  reducers: {
    mutateJobSubscription: (state, action) => {
      // find if job is exists?
      const index = state.items.findIndex(item => `${item.user_id}/${item.job_id}` === `${action.payload.user_id}/${action.payload.job_id}`);
      if (index > -1) {
        const newItems = state.items.map(item => {
          if (`${item.user_id}/${item.job_id}` === `${action.payload.user_id}/${action.payload.job_id}`) {
            return {
              ...item,
              ...action.payload
            }
          }
          return item;
        });

        return {
          ...state,
          items: newItems,
        }
      }

      // new job
      return {
        ...state,
        items: state.items.length === 0
          ? [action.payload]
          : [...state.items, action.payload],
        details: state.details 
          ? `${state.details.user_id}/${state.details.job_id}` === `${action.payload.user_id}/${action.payload.job_id}` 
              ? {...state.details, ...action.payload}
              : state.details
          : null
      }
    },
    selectJobForDetails: (state, action) => {
      return {
        ...state,
        details: action.payload,
      }
    },
    resetJobReports: (state, action) => {
      return {
        ...state,
        reports: [],
      }
    }
  },
  extraReducers: builder => {
    builder

      // fetchOpenJobServices
      .addCase(fetchOpenJobServices.pending, queryOpenJobServices.pending)
      .addCase(fetchOpenJobServices.fulfilled, queryOpenJobServices.fulfilled)
      .addCase(fetchOpenJobServices.rejected, queryOpenJobServices.rejected)

      // fetchJobServiceDetails
      .addCase(fetchJobServiceDetails.pending, getJobService.pending)
      .addCase(fetchJobServiceDetails.fulfilled, getJobService.fulfilled)
      .addCase(fetchJobServiceDetails.rejected, getJobService.rejected)

      // fetchJobServiceReports
      .addCase(fetchJobServiceReports.pending, getJobReports.pending)
      .addCase(fetchJobServiceReports.fulfilled, getJobReports.fulfilled)
      .addCase(fetchJobServiceReports.rejected, getJobReports.rejected)
  },
});

export const { mutateJobSubscription, selectJobForDetails, resetJobReports } = slice.actions;
const { reducer } = slice;
export default reducer;